<div class="form-group input-content mb-0">
  <div class="w-100">
    <p-dropdown  
        [options]="campaignsBasicInfo" 
        [(ngModel)]="selectedCampaigns"
        optionValue="id"
        (onChange)="onSelect.emit(selectedCampaigns)"
        optionLabel="name"
        placeholder="Choose Campaign"
        [panelStyle]="{minWidth:'12em'}"
    >
      <ng-template let-campaign pTemplate="item" style="width: 200px;">
        <div class="container-select">
          <div
            class="d-inline-flex justify-content-between"
            [ngStyle]="{'width': '10px', 'height': '10px'}"
            [style.backgroundColor]="campaign?.color ? 'rgb('+campaign.color+')' : 'transparent'"
          ></div>

          <span class={class}>
            {{campaign.name}}
          </span>   
        </div>
      </ng-template>
    </p-dropdown>
  </div>
</div>
